import { useSelector } from 'react-redux';

export default function useActiveBrand() {
  return useSelector(state => state.layout.activeBrand);
}
